module.exports = __webpack_public_path__ + "images/Play Hover.svg";